import React from 'react';
import { Link } from "react-router-dom";
import { Button, Modal } from "react-bootstrap";
import 'datatables.net';
import 'datatables.net-dt/css/dataTables.dataTables.css';

const EditProdType = ({ show, onClose }) => {

    return (
        <Modal className="modal fade" show={show} size="md">
            <div className="modal-content">
                <div className="modal-header" style={{ backgroundColor: '#3ab384' }}>
                    <h3 className="modal-title text-white">Update Product Type</h3>
                    <Button variant="" type="button" className="close px-6 py-2" data-dismiss="modal" onClick={onClose}>
                        <span className="text-white">×</span>
                    </Button>
                </div>
                <div className="modal-body">
                    <div className="row"> 
                        <div className="col-lg-12 mb-2">
                            <label className="text-black font-w500 fs-7">Product Type<span className="required">*</span></label>
                            <input type="text" className="form-control" placeholder="Enter Product Type" value="Regular" />
                        </div>
                        <div className="col-lg-12 mb-2">
                            <label className="text-black font-w500 fs-7">Description<span className="required">*</span></label>
                            <textarea rows={8} className="form-control h-auto" name="comment" placeholder="Description" defaultValue={"Standard-sized products designed to meet typical serving or usage needs, offering a full portion or quantity. These are ideal for individuals or families who require standard portions."} />
                        </div>
                    </div>
                    <div className="d-flex align-items-center justify-content-center gap-3 mt-4">
                        <Link type="reset" className="btn btn-sm btn-secondary" onClick={onClose}>Cancel</Link>
                        <Link type="submit" className="btn btn-sm btn-primary" onClick={onClose}>Update Product Type</Link>
                    </div>
                </div>
            </div>
        </Modal>
    );
};

export default EditProdType;